import { useQuery } from "@tanstack/react-query";

export const attendeeKeys = {
  all: ["attendees"],
  lists: () => [...attendeeKeys.all, "list"],
  list: (filters) => [...attendeeKeys.lists(), { filters }],
  items: () => [...attendeeKeys.all, "item"],
  item: (attendeeId) => [...attendeeKeys.items(), attendeeId],
};

export function useAttendee(func, args, queryOptions = {}) {
  return useQuery({
    queryKey: attendeeKeys.item(args.attendeeId),
    queryFn: () => func(args.attendeeId),
    ...queryOptions,
  });
}

export function useAttendees(func, args, queryOptions = {}) {
  return useQuery({
    queryKey: attendeeKeys.list(args.filters),
    queryFn: () => func(args.filters),
    ...queryOptions,
  });
}
